export default __webpack_public_path__ + "static/media/5_TakeFive.21d9ee7f.mp3";